import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Locale resources, imported statically for the initial bundle.
import svCommon from '@/locales/sv/common.json'
import enCommon from '@/locales/en/common.json'
import {
  getStoredLanguage,
  initDomTranslation,
  setDomLanguage,
  type AppLanguage,
} from '@/lib/translate/engine'

export type { AppLanguage }

const resources = {
  sv: { common: svCommon },
  en: { common: enCommon },
} as const

// Honor the visitor's previously chosen language on first paint.
const initialLang = getStoredLanguage()

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: 'sv',
  defaultNS: 'common',
  ns: ['common'],

  interpolation: {
    // React already escapes rendered values, no need for i18next to double-escape.
    escapeValue: false,
  },

  // Return key as fallback when resource is missing (useful for dev/test).
  returnNull: false,
})

// Single source of truth: whenever the language changes through i18next
// (toggle, footer switcher, anywhere), drive the runtime DOM translation
// engine so the whole site, not just t()-wired components, follows along.
i18n.on('languageChanged', (lng) => {
  setDomLanguage(lng === 'en' ? 'en' : 'sv')
})

// Boot the DOM engine (starts the observer and applies the stored language).
initDomTranslation()

/**
 * Set the application language everywhere.
 * Prefer this over calling i18n.changeLanguage directly.
 */
export function setAppLanguage(lang: AppLanguage): void {
  void i18n.changeLanguage(lang)
}

/** The currently active language, normalized to 'sv' | 'en'. */
export function getAppLanguage(): AppLanguage {
  return i18n.language === 'en' ? 'en' : 'sv'
}

export default i18n
